export const subCodeGroupCode = {
    HTPREG: 'HTPREG',
    HTPOT1: 'HTPOT1',
    HTPOT2: 'HTPOT2',
    HTPVAC: 'HTPVAC',
    HTPABS: 'HTPABS',
    HTPPRI: 'HTPPRI',
    HTPAUT: 'HTPAUT',
};